import { DecisionModelProcessType } from './enums/DecisionModelProcessType';
import { ProductType } from './enums/product-type.enum';

export class DecisionModelWorkflow {
  decisionModelProcessType: DecisionModelProcessType;
  productType: ProductType;
  customerId: number;
  firsDate: string;
  secondDate: string;
}
